import type { getWorldCupGroupStageTableCardStyles } from './WorldCupGroupStageTableCard.styles';
import { QUALIFYING_POSITION_LIMIT, POSSIBLE_3RD_POSITION } from './worldCupStandingsModal.constants';

type CardStyles = ReturnType<typeof getWorldCupGroupStageTableCardStyles>;

export function formatGd(gd: number): string {
  if (gd > 0) return `+${gd}`;
  return String(gd);
}

export function getGdStyle(gd: number, styles: CardStyles) {
  if (gd > 0) return styles.cellGdPositive;
  if (gd < 0) return styles.cellGdNegative;
  return styles.cellGdZero;
}

/**
 * Qualification highlighting differs by table: regular groups highlight the top 2
 * plus a "possible 3rd" row; the third-placed-teams ranking highlights the top 8
 * (and has no possible-3rd row). Defaults keep the regular-group behaviour.
 */
export interface QualifyHighlightOptions {
  qualifyLimit?: number;
  showPossibleThird?: boolean;
}

export function getPositionBarStyle(
  position: number,
  styles: CardStyles,
  opts: QualifyHighlightOptions = {},
) {
  const { qualifyLimit = QUALIFYING_POSITION_LIMIT, showPossibleThird = true } = opts;
  if (position <= qualifyLimit) return styles.positionBarQualified;
  if (showPossibleThird && position === POSSIBLE_3RD_POSITION) return styles.positionBarPossible3rd;
  return styles.positionBarEliminated;
}

export function getDataRowStyle(
  index: number,
  hasResults: boolean,
  isLast: boolean,
  styles: CardStyles,
  opts: QualifyHighlightOptions = {},
) {
  const { qualifyLimit = QUALIFYING_POSITION_LIMIT, showPossibleThird = true } = opts;
  const qualifies = index < qualifyLimit;
  const thirdRow = showPossibleThird && index === qualifyLimit;
  return [
    styles.dataRow,
    qualifies && styles.rowQualified,
    thirdRow && hasResults && styles.rowPossibleThird,
    isLast && styles.dataRowLast,
  ];
}
